import React, { useState } from "react";
import useApiEp from "../../hooks/useApiEp";
import { Container } from "@mui/material";
import VisibilityOutlinedIcon from "@mui/icons-material/VisibilityOutlined";
import DeleteOutlineIcon from "@mui/icons-material/DeleteOutline";
import EditOutlinedIcon from "@mui/icons-material/EditOutlined";
import {
  Box,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
  TablePagination,
  Typography,
  CircularProgress,
  Alert,
  Button,
  Grid,
  IconButton,
  Stack,
  Tooltip,
  Chip,
} from "@mui/material";
import BackBtn from "../../widgets/BackBtn";
import { useNavigate } from "react-router-dom";
import PageTitle from "../../widgets/PageTitle";
import ContentCopyIcon from "@mui/icons-material/ContentCopy";
import { toast } from "react-toastify";
import CursorNavButtons from "../../widgets/CursorNavButtons";
import TopTitleActions from "../../widgets/TopTitleActions";
import SmartToyOutlinedIcon from "@mui/icons-material/SmartToyOutlined";
import MuPb from "../../widgets/MuPb";
import { getErrorResponse, getHeader, toastError } from "../../utils/util";
import SimpleYesNoDialog from "../../widgets/SimpleYesNoDialog";
import { API_ENDPOINT } from "../../utils/constants";
import axios from "axios";
import CustomCircularP from "../../widgets/CustomCircularP";
const StatusChip = ({ status }) => {
  const color = status.toLowerCase() === "published" ? "success" : "default";
  const label = status.charAt(0).toUpperCase() + status.slice(1);
  return <Chip label={label} color={color} size="small" />;
};
const copyToClipboard = (text) => {
  navigator.clipboard
    .writeText(text)
    .then(() => toast.success("ID copied to clipboard!"))
    .catch(() => toast.error("Failed to copy ID"));
};
const FlowsList = () => {
  const navigate = useNavigate();
  const [navCode, setNavCode] = useState("");
  const [showDelete, setShowDelete] = useState(false);
  const [toDeleteId, setToDeleteId] = useState("");
  const [deleting, setDeleting] = useState(false);
  const { data, isLoading, isError, error, refetch } = useApiEp(
    `/api/get-flows?navCode=${navCode}`
  );
  if (isLoading) {
    return <MuPb />;
  }
  if (isError) {
    return <Alert severity="error">{getErrorResponse(error)}</Alert>;
  }
  const handleAddFlow = () => {
    navigate(`/home/create-flow`);
  };
  return (
    <Container maxWidth="md" sx={{ mt: 3 }}>
      <BackBtn />
      <TopTitleActions
        title="Forms List"
        actions={[
          {
            icon: <SmartToyOutlinedIcon />,
            label: "Add Flow",
            action: handleAddFlow,
          },
        ]}
      />
      <CustomCircularP show={deleting} />
      <SimpleYesNoDialog
        show={showDelete}
        setShow={setShowDelete}
        title={"Please confirm!"}
        message={"Are you sure you want to delete this item?"}
        onYes={async () => {
          try {
            setDeleting(true);
            setShowDelete(false);
            const response = await axios.delete(
              `${API_ENDPOINT}/api/delete-flow/${toDeleteId}`,
              getHeader()
            );
            toast.success(response.data.message);
            refetch();
          } catch (error) {
            toastError(error);
          } finally {
            setDeleting(false);
          }
        }}
      />
      <TableContainer sx={{ mt: 2 }}>
        <Table stickyHeader>
          <TableHead>
            <TableRow>
              <TableCell>Name</TableCell>
              <TableCell>ID</TableCell>
              <TableCell>Category</TableCell>
              <TableCell>Status</TableCell>
              <TableCell align="center">Action</TableCell>
            </TableRow>
          </TableHead>
          <TableBody>
            {(data?.data?.length > 0
              ? data.data
              : data?.products?.length > 0
              ? data.products
              : []
            ).length > 0 ? (
              (data?.data || data?.products || []).map((item) => (
                <TableRow hover key={item._id}>
                  <TableCell>{item.name}</TableCell>
                  <TableCell
                    sx={{ display: "flex", alignItems: "center", gap: 1 }}
                  >
                    {item.id}
                    <Tooltip title="Copy ID">
                      <IconButton
                        size="small"
                        onClick={() => copyToClipboard(item.id)}
                        aria-label="copy id"
                      >
                        <ContentCopyIcon fontSize="small" />
                      </IconButton>
                    </Tooltip>
                  </TableCell>
                  <TableCell>{item.categories?.join(", ") || "-"}</TableCell>
                  <TableCell>
                    <StatusChip status={item.status} />
                  </TableCell>
                  <TableCell align="center">
                    <Stack direction={"row"} spacing={1}>
                      <IconButton
                        onClick={() =>
                          navigate(`/home/${item.id}/flow-details`)
                        }
                        color="info"
                        size="small"
                        aria-label="view details"
                      >
                        <VisibilityOutlinedIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        onClick={() => {
                          setToDeleteId(item.id);
                          setShowDelete(true);
                        }}
                        color="error"
                        size="small"
                        aria-label="delete item"
                      >
                        <DeleteOutlineIcon fontSize="small" />
                      </IconButton>
                      <IconButton
                        onClick={() =>
                          navigate(`/home/${item.id}/forms-flow-builder`)
                        }
                        color="info"
                        size="small"
                        aria-label="edit item"
                      >
                        <EditOutlinedIcon fontSize="small" />
                      </IconButton>
                    </Stack>
                  </TableCell>
                </TableRow>
              ))
            ) : (
              <TableRow>
                <TableCell colSpan={5} align="center">
                  No flows found!
                </TableCell>
              </TableRow>
            )}
          </TableBody>
        </Table>
      </TableContainer>
      {/* <Box my={1} py={1}>
        <CursorNavButtons
          cursors={
            data?.paging?.cursors ? data?.paging?.cursors : data?.cursors
          }
          onNav={(newV) => {
            setNavCode(newV);
          }}
        />
      </Box> */}
    </Container>
  );
};

export default FlowsList;
